module.exports = __webpack_public_path__ + "static/home_background_1-377aebd7fcedde229c1a753b71a4d746.jpg";